import { arrayOf, bool, number, object, oneOfType, shape, string } from 'prop-types';

import messageDescriptor from '../../lingui/LinguiPropTypes';

export const panelPropTypes = {
    title: oneOfType([string, messageDescriptor]),
    hideTitle: bool,
    hideActions: bool,
    expandable: bool,
    width: number,
    minWidth: number,
    autoHeight: bool,
    flexHeight: bool,
    contentHeight: number,
    minContentHeight: number,
    disableVerticalResize: bool,
    overrides: shape({
        options: object,
        filters: object,
    }),
    stateSummaryOptions: shape({
        show: bool,
        excludedFilters: arrayOf(string),
    }),
};

export const panelPropDefaults = {
    hideTitle: false,
    hideActions: false,
    expandable: false,
    width: 12,
    minWidth: 3,
    autoHeight: false,
    flexHeight: false,
    contentHeight: 200,
    minContentHeight: 200,
    disableVerticalResize: false,
    overrides: undefined,
    stateSummaryOptions: {
        show: false,
        excludedFilters: [],
    },
};
